<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-input-group>
            <b-input-group-prepend > 
              <label style="min-width: 150px">Periode</label>
            </b-input-group-prepend>
            <b-form-input v-model="model.tgl2" 
            type="date" class="ml-3" 
            :max="maxdtreport"
            :state="!$v.model.tgl2.$error"></b-form-input>
            <b-input-group-append>
              <b-button
                variant="success"
                @click="getLBPP()"
                class="ml-3"
              >
                <i class="fa fa-play"></i> Proses
              </b-button>
              <b-button variant="primary ml-2" @click="exportxlsLBPP()">
                <i class="fa fa-file-excel-o"></i>Export
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :filter="filterInput"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(index)="data">{{((tblData.page-1)*tblData.limit)+( data.index + 1) }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(bunga_tarifthn)="data">{{
            data.item.bunga_tarifthn | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(bucket4_gross)="data">{{
            data.item.bucket4_gross | numFormat("0,0")
          }}</template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>
      <b-row class="m-1">
        <b-col lg="6">
          <b-row v-if="filterShow == 'Hide'">
            <b-input-group size="sm">
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              ></b-form-checkbox>
              <b-input-group-prepend>
                <span class="pr-2">
                  <b> {{ filterShow }}</b> Filter
                </span>
              </b-input-group-prepend>
              <b-form-input
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
            <b-input-group size="sm" class="ml-4">
              <b-input-group-prepend class="ml-5">
                <span class="pr-2">On</span>
              </b-input-group-prepend>
              <b-form-checkbox-group v-model="filterOn" class="mt-1">
                <b-form-checkbox value="no_agreement"
                  >Agreement No.</b-form-checkbox
                >
                <b-form-checkbox value="CustName">Debitur Name</b-form-checkbox>
              </b-form-checkbox-group>
            </b-input-group>
            <label class="text-muted small" style="margin-left: 100px"
              >Leave all unchecked to filter on all data</label
            >
          </b-row>
          <b-row v-else>
            <b-form-checkbox
              v-model="filterShow"
              value="Hide"
              unchecked-value="Show"
              switch
            >
              <b> {{ filterShow }}</b> Filter
            </b-form-checkbox>
          </b-row>
        </b-col>
        <b-col lg="6">
          <div style="display: flex; margin: 0; padding: 0">
            <div
              style="margin: 0; padding: 5px; width: 500px; text-align: right"
            >
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to
              <span v-if="tblData.page * tblData.limit > tblData.total">{{
                tblData.total
              }}</span>
              <span v-else>{{ tblData.page * tblData.limit }}</span> of
              {{ tblData.total }} , <span class="mr-1">limit per page :</span>
              <select v-model="tblData.limit" style="width: 60px">
                <option>10</option>
                <option>15</option>
                <option>20</option>
                <option>25</option>
                <option>30</option>
                <option>40</option>
                <option>50</option>
                <option>60</option>
                <option>70</option>
                <option>80</option>
                <option>90</option>
              </select>
            </div>
            <div>
              <b-pagination
                class="ml-1"
                align="left"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isBusy"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import myNumber from "../../components/my-number";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import VueMonthlyPicker from 'vue-monthly-picker';

toastr.init();
export default {
  components: { myNumber, VueMonthlyPicker, Loading },
  mixins: [validationMixin],
  validations: {
    model: {
        tgl2:{required}
    },
  },
  data() {
    return {
      maxdtreport : moment(this.$store.state.timeServer).subtract(1,'days').format('YYYY-MM-DD'),
      showFilter: true,
      isBusy: false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        date:'',
        
      },
      isLoading:false,
      monthLabels:dropdown.monthLabels,
      model: {tgl1:'',tgl2:moment().endOf('month').format('YYYY-MM-DD'),periode:moment().format('YYYY-MM-DD')},
      filterShow:'Show',
      filter: null,
      filterInput: null,
      filterOn: ['no_agreement','CustName'],   
      
    };
  },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "#",
          thStyle: "width:140px",
        },
        {
          key: "no_agreement",
          label: "NMR KNTRK",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "CustCode",
          label: "NMR DBTR",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "CustName",
          label: "NM DBTR",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "grp_phk_lwn",
          label: "GRP PHK LWN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "ktgr_sh_dbtr",
          label: "KTGR SH DBTR",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "ktgr_sh_kngn_brklnjtn",
          label: "KTGR SH KNGN BRKLNJTN",
          thStyle: "min-width:200px",
          sortable: true,
        },
        {
          key: "glngn_phk_lwn",
          label: "GLNGN PHK LWN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "stts_ktrktn",
          label: "STTS KTRKTN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "sktr_knm_lpngn_sh",
          label: "SKTR KNM LPNGN SH",
          thStyle: "min-width:200px",
          sortable: true,
        },
        {
          key: "lks_dt_pryk",
          label: "LKS DT PRYK",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "no_agreement",
          label: "NMR KNTRK",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "jns_pmbyn",
          label: "JNS PMBYN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "skm_pmbyn",
          label: "SKM PMBYN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "tjn_pmbyn",
          label: "TJN PMBYN",
          thStyle: "min-width:140px",
          sortable: true,
        },

        {
            key: "tnggl_ml",
            label: "TNGGL ML",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "tnggl_jth_tmp",
            label: "TNGGL JTH TMP",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
            key: "nl_trctt",
            label: "NL TRCTT",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "tghn_pmbyn_dlm_mt_ng_sl",
            label: "TGHN PMBYN DLM MT NG SL",
            thStyle: "min-width:220px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "tghn_pmbyn",
            label: "TGHN PMBYN",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "ptng_pmbyn_pkk_dlm_mt_ng_sl",
            label: "PTNG PMBYN PKK DLM MT NG SL",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "ptng_pmbyn_pkk",
            label: "PTNG PMBYN PKK",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "prs_prshn_pd_pmbyn_brsm",
            label: "PRS PRSHN PD PMBYN BRSM",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "jns_mt_ng",
          label: "JNS MT NG",
          thStyle: "min-width:140px",
          sortable: true,
        },

        {
            key: "ng_mk",
            label: "NG MK",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "phk_lwn_krjsm_pmbyn_brsm_jnt_fnncng",
          label: "PHK LWN KRJSM PMBYN BRSM JNT FNNCNG",
          thStyle: "min-width:320px",
          sortable: true,
        },

        {
            key: "by_nsntf_kss_pmbyn_kpd_phk_ktg",
            label: "BY NSNTF KSS PMBYN KPD PHK KTG",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "jns_bngmrgnbg_hslmbl_js",
          label: "JNS BNGMRGNBG HSLMBL JS",
          thStyle: "min-width:250px",
          sortable: true,
        },

        {
            key: "nl_mrgnmbl_js",
            label: "NL MRGNMBL JS",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "tngkt_bngbg_hsl",
            label: "TNGKT BNGBG HSL",
            thStyle: "min-width:200px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "bngmrgn_dtngghkn_dlm_mt_ng_sl",
            label: "BNGMRGN DTNGGHKN DLM MT NG SL",
            thStyle: "min-width:300px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "bngmrgn_dtngghkn",
            label: "BNGMRGN DTNGGHKN",
            thStyle: "min-width:200px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "pndptn_dmnstrs",
            label: "PNDPTN DMNSTRS",
            thStyle: "min-width:200px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "pndptn_prvs",
            label: "PNDPTN PRVS",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "ktgr_ptng",
          label: "KTGR PTNG",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "klts",
          label: "KLTS",
          thStyle: "min-width:140px",
          sortable: true,
        },

        {
            key: "tnggl_jth_tmp_pmbyrn_trkhr",
            label: "TNGGL JTH TMP PMBYRN TRKHR",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "tnggl_pmbyrn_ngsrn_trkhr",
            label: "TNGGL PMBYRN NGSRN TRKHR",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "angsrn_ke",
            label: "ANGSRN KE",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "nl_pmbyrn_ngsrn_trkhr",
            label: "NL PMBYRN NGSRN TRKHR",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "jns_brng_dn_js",
          label: "JNS BRNG DN JS",
          thStyle: "min-width:140px",
          sortable: true,
        },

        {
            key: "nl_brngjs_yng_dby",
            label: "NL BRNGJS YNG DBY",
            thStyle: "min-width:200px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "mtd_pmbntkn_cdngn_krgn_pnrnn_nl",
          label: "MTD PMBNTKN CDNGN KRGN PNRNN NL",
          thStyle: "min-width:300px",
          sortable: true,
        },

        {
            key: "nl_st_bk_cdngn_krgn_pnrnn_nl",
            label: "NL ST BK CDNGN KRGN PNRNN NL",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "nl_st_krng_bk_cdngn_krgn_pnrnn_nl",
            label: "NL ST KRNG BK CDNGN KRGN PNRNN NL",
            thStyle: "min-width:300px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "nl_st_tdk_bk_cdngn_krgn_pnrnn_nl",
            label: "NL ST TDK BK CDNGN KRGN PNRNN NL",
            thStyle: "min-width:300px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "prprs_pnjmnn_krdt_t_srns_krdt",
            label: "PRPRS PNJMNN KRDT T SRNS KRDT",
            thStyle: "min-width:300px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "nm_prshn_srns",
          label: "NM PRSHN SRNS",
          thStyle: "min-width:140px",
          sortable: true,
        },

        {
            key: "jngk_wkt_srns",
            label: "JNGK WKT SRNS",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "prm_lh_knsmn",
            label: "PRM LH KNSMN",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "dskn_prm",
            label: "DSKN PRM",
            thStyle: "min-width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "nmr_gnn",
          label: "NMR GNN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "jns_gnn",
          label: "JNS GNN",
          thStyle: "min-width:140px",
          sortable: true,
        },

        {
            key: "nl_gnnjmnn_yng_dpt_dprhtngkn",
            label: "NL GNNJMNN YNG DPT DPRHTNGKN",
            thStyle: "min-width:250px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

        {
          key: "jns_pngktn_gnn",
          label: "JNS PNGKTN GNN",
          thStyle: "min-width:140px",
          sortable: true,
        },
        {
          key: "nmr_srtfkt_kpmlkn_gnn",
          label: "NMR SRTFKT KPMLKN GNN",
          thStyle: "min-width:250px",
          sortable: true,
        },
        {
          key: "nmr_srtfkt_pngktn_gnn",
          label: "NMR SRTFKT PNGKTN GNN",
          thStyle: "min-width:250px",
          sortable: true,
        },
        {
          key: "tnggl_srtfkt_pngktn_gnn",
          label: "TNGGL SRTFKT PNGKTN GNN",
          thStyle: "min-width:250px",
          sortable: true,
        },
        {
          key: "pss_pnympnn_srtfkt_gnn",
          label: "PSS PNYMPNN SRTFKT GNN",
          thStyle: "min-width:250px",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch:{
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 800);
    },
  }, 

  async created() {
    this.model.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD');
    this.model.tgl2=moment(this.model.periode).endOf('month').format('YYYY-MM-DD');
    // .add(1,'M').subtract(1, 'day');
    console.log('this.model.periode',this.model.periode);
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },     
    clearFilter() {
          //this.filterOn= []   
          this.filter= '';   
    } ,

    onChangeMonth: async function (){
        var tgl=this.model.periode;
        this.model.tgl2=moment(tgl).endOf('month').format('YYYY-MM-DD');
        this.$forceUpdate();
    }, 
    async getLBPP() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        try {
            this.isBusy = true;
            const result = await pinjaman.LBPP(this.model);
            this.tblData.items = result;
            this.tblData.total = result ? result.length : 0;
            this.isBusy = false;
        } catch (error) {
            this.isBusy=false;
            if (error.message) {
                toastr.error(error.message,'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error),'Error Info',10000);
            }
        }
       }

    },
    async exportxlsLBPP() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
      try {
        this.isBusy = true;
        await pinjaman.exportxlsLBPP(this.model);
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
       }
    },
    close() {
      router.push("home");
    },
  },
};
</script>